"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upperCaseFirst = upperCaseFirst;
function upperCaseFirst(text) {
  return text[0] ? text[0].toUpperCase() + text.slice(1) : text;
}
